interface IncidentCorrelationIconProps {
  size?: number;
  color?: string;
}

/**
 * Incident Correlation Icon Component
 * @description A shield with lightning bolt representing incident protection and alerts
 */
export const IncidentCorrelationIcon: React.FC<IncidentCorrelationIconProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976M13 10V5l-5 7h3v5l5-7z"
      />
    </svg>
  );
};

export default IncidentCorrelationIcon;
